import React from 'react';
import { Button } from 'react-bootstrap';
import { images } from 'utils';

interface StateProps {
    getMyCurrentLocation: () => void;
}
interface Props extends StateProps { };
const Location: React.FC<Props> = (props) => {

    return (
        <React.Fragment>
            <div id="Location" className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="text-center" style={{ width: '65vw' }}>
                    <img src={images.GMap} alt="GMap" height={85} />
                    <div className="fw-500 mt-3">Where are you right now?</div>
                    <div className="mb-4">We need to know you current location.</div>

                    <Button variant="primary btn-md" onClick={() => window.location.reload()}>
                        &nbsp; &nbsp; Okay &nbsp; &nbsp;
                    </Button>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Location;